import React, {useEffect, useState} from 'react';
import axios from "axios";
import PlanCard from "./PlanCard";
import {handleError} from "../HandleError";
import localized from "../../i18n";
import {Card, Col, Row} from 'react-bootstrap';
import {BsCheckLg} from "react-icons/bs";


const PricingPlan = () => {
    const [planLists, setPlans] = useState([]);
    // const [currency, setCurrency] = useState("EUR");

    let initialized = false;
    useEffect(() => {
        if (!initialized) {
            initialized = true;
            getFilesList();
        }
    }, []);

    const getFilesList = () => {
        axios.get("/api/get-plan")
            .then((response) => {
                setPlans(response.data.data);
            }).catch((err) => {
            handleError(err);
        })
    };

    // const handleCurrencyChange = (isUSD) => {
    //     setCurrency(isUSD ? "USD" : "EUR");
    // };

    return (
        <>
            <div className='pricing-container'>
                <div className="container-fluid">
                    <div className='pricing-header d-flex justify-content-between align-items-start gap-3'>
                        <div/>
                        <h1 className="mb-0">{localized.pricing_header}</h1>
                        <div className="currency-switch d-flex align-items-center gap-2 mt-1">
                            {/*<label htmlFor="currency-toggle" className="mb-0">EUR</label>*/}
                            {/*<input*/}
                            {/*    type="checkbox"*/}
                            {/*    id="currency-toggle"*/}
                            {/*    onChange={(e) => handleCurrencyChange(e.target.checked)}*/}
                            {/*/>*/}
                            {/*<label htmlFor="currency-toggle" className="mb-0">USD</label>*/}
                        </div>
                    </div>

                    <div className='pricing-plan-main'>
                        {(planLists || []).filter((p) => {
                            return p.type === 1
                        }).length !== 0 && (
                            <Row className='justify-content-center'>
                                <div className='pricing-plan-header'>
                                    <h1>{localized.subscription}</h1>
                                    <p>{localized.pricing_desc}</p>
                                </div>
                            </Row>
                        )}

                        <Row className='main-plan'>
                            {planLists.filter((p) => {
                                return p.type === 1
                            }).map((item, index) => (
                                <Col key={index} xl={3} md={6} sm={12}>
                                    <PlanCard plan={item} index={index} key={index}/>
                                </Col>
                            ))}
                        </Row>

                        {(planLists || []).filter((p) => {
                            return p.type === 2
                        }).length !== 0 && (
                            <Row className='justify-content-center'>
                                <div className='pricing-plan-header'>
                                    <h1>{localized.addition_credits}</h1>
                                    <p>{localized.credit_desc}</p>
                                </div>
                            </Row>
                        )}

                        <Row className='main-plan'>
                            {planLists.filter((p) => {
                                return p.type === 2
                            }).map((item, index) => (
                                <Col key={index} xl={3} md={6} sm={12}>
                                    <PlanCard plan={item} index={index} key={index}/>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PricingPlan;